document.addEventListener("DOMContentLoaded", function () {


  var productGrids = document.querySelectorAll(".flex.product-grid");

  function initializeAllProductGrids() {
    productGrids.forEach(initializeProductGrid);
  }
  if(productGrids){
  initializeAllProductGrids();
  var productGrid = document.querySelector('#product-grid');
  if(productGrid){
  const endlessCollection = new Ajaxinate({
    container: "#product-grid",
    pagination: "#AjaxinatePagination",
    offset: 30000,
    callback: initializeAllProductGrids
  });}
}

  // --- Centralized resize listener ---
});
function updateProductImage(card, variantData, variantId) {
  var productImageElement = card.querySelector(".card__media img");

  if (productImageElement) {
    var lazyLoadAllVariants =
      card.getAttribute("data-lazy-load-all-variants") === "true";
    if (lazyLoadAllVariants) {
      var preloadedImage = card.querySelector(
        `img[data-variant-id="${variantId}"]`
      );
      if (preloadedImage) {
        productImageElement.src = preloadedImage.src;
        productImageElement.srcset = preloadedImage.srcset;
      }
    } else if (variantData && variantData.imageUrl) {
      var dynamicSrcset = [
        `${variantData.imageUrl}?width=165 165w`,
        `${variantData.imageUrl}?width=360 360w`,
        `${variantData.imageUrl}?width=533 533w`,
        `${variantData.imageUrl}?width=720 720w`,
        `${variantData.imageUrl}?width=940 940w`,
        `${variantData.imageUrl}?width=1066 1066w`,
      ].join(", ");
      productImageElement.srcset = dynamicSrcset;
      productImageElement.src = variantData.imageUrl;
    }
  }
}

function updateProductLinks(card, variantData, variantId) {
  var productLinks = card.querySelectorAll(
    'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]'
  );
  productLinks.forEach(function (link) {
    link.href = variantData.productUrl;
  });

   var quickAddButton = card.querySelector('.buy-button-main'); // Select the button with the correct class
var productIdInput = card.querySelector('input[name="id"]'); 
if (quickAddButton && productIdInput ) {
    // Check variant availability
      // Disable the "Add to Cart" button 
      if (variantData.available) {
        productIdInput.value = variantId;
        quickAddButton.disabled = false; // Enable the button 
      } else {
        productIdInput.value = variantId;
        quickAddButton.disabled = true; // Disable the button
      }

  } else {
    console.error(
      "Error: Could not find quickAddButton or buttonInput element."
    );
  }
}

function updateProductPrice(card, variantData) {
  const priceContainer = card.querySelector(".price__container");
  const salePriceElement = priceContainer.querySelector(
    ".price-item.price-item--sale.price-item--last"
  );
  const compareAtPriceElement = priceContainer.querySelector(
    "s.price-item.price-item--regular"
  );
  const priceParentContainer = card.querySelector(".price");
  const regularPrice = priceParentContainer.querySelector(".price__regular #ProductPrice")
  if (variantData) {
    if (variantData.compareAtPrice != ''){
      if (!priceParentContainer.classList.contains("price--on-sale")) {
        priceParentContainer.classList.add("price--on-sale");
      }
    }else if (priceParentContainer.classList.contains("price--on-sale")) {      
      priceParentContainer.classList.remove("price--on-sale");
    }

    // Update sale price
    if (salePriceElement) {
      salePriceElement.textContent = variantData.price;
    }
    if (compareAtPriceElement) {
      compareAtPriceElement.textContent = variantData.compareAtPrice;
      
    }
    if (regularPrice){
      priceParentContainer.querySelector(".price__regular #ProductPrice").textContent = variantData.price;
    }
  }
}

function restoreSelectedSwatch(productGrid, sectionId, productId) {
  var selectedVariantId = sessionStorage.getItem(
    "selectedSwatch-" + sectionId + "-" + productId
  );
  if (selectedVariantId) {
    // First, try to find a radio button with the selected variant ID
    var swatchInput = productGrid.querySelector(
      `input[type="radio"][data-variant-id="${selectedVariantId}"][data-section-id="${sectionId}"]`
    );
    if (swatchInput) {
      swatchInput.checked = true;
    } else {
      // If no radio button is found, try to find a select element
      var selectElement = productGrid.querySelector(
        `select[data-section-id="${sectionId}"][data-product-id="${productId}"]`
      );
      if (selectElement) {
        // Loop through options to find the one with the matching variant ID
        for (var i = 0; i < selectElement.options.length; i++) {
          var option = selectElement.options[i];
          if (option.getAttribute("data-variant-id") === selectedVariantId) {
            selectElement.selectedIndex = i; // Select the matching option
            break;
          }
        }
      }
    }
  }
}

function initializeProductGrid(productGrid) {
  var sectionId = productGrid.getAttribute("data-id");
  productGrid
    .querySelectorAll(".card-product-custom-div")
    .forEach(function (card) {
      var productId = card.getAttribute("data-product-id");
      // Generate and store variantDataMap for later use
      restoreSelectedSwatch(productGrid, sectionId, productId);
      var dataMap = generateVariant(card);

      // Log the dataMap to inspect its contents
      console.log("dataMap for product ID", productId, ":", dataMap); 
      
      card.addEventListener('change', (e) => handleVariantSelection(e, card, dataMap));

      card.classList.add("loaded");
    });
}

function generateVariant(card) {
  const variantData = {};
  // Parse the JSON from the script tag
  const scriptTag = card.querySelector('.json-variant-data'); // Use template literal
  if (scriptTag) {
  const jsonText = scriptTag.innerHTML.replace(/,\s*$/, ''); 
  const productData = JSON.parse(jsonText);
  // Get the product title (the key of the outer object)
  const productTitle = Object.keys(productData)[0]; 

  // Access the inner object containing the variants
  const variants = productData[productTitle]; 

  for (const variantId in variants) {
    const variant = variants[variantId];
    variantData[variantId] = {
      imageUrl: variant.imageUrl,
      productUrl: variant.productUrl,
      compareAtPrice: variant.compareAtPrice,
      price: variant.price,
      available: variant.available,
    };
  }

  return variantData;
  
} else {
  return null;
}
}
function handleVariantSelection(e, card, dataMap) {
  const sectionId = card.dataset.sectionId; // Get sectionId from the card itself

  if (
    e.target.matches(`input[type="radio"][data-section-id="${sectionId}"]`) ||
    e.target.matches(`select[data-section-id="${sectionId}"]`)
  ) {
    const variantId =
      e.target.getAttribute('data-variant-id') ||
      e.target.options[e.target.selectedIndex].getAttribute('data-variant-id');

    console.log('Selected variantId:', variantId);

    const variantData = dataMap[variantId];

    console.log('variantData found:', !!variantData);

    if (!variantData) {
      console.error('No variantData found for variantId:', variantId);
      return;
    }

    const badge = card.querySelector('.card__badge.bottom.center');
    if (badge) {
      badge.style.display = 'none';
    }

    updateProductImage(card, variantData, variantId);
    updateProductLinks(card, variantData, variantId);
    updateProductPrice(card, variantData);
  }
}


function initializeAllProductGridsSkinCare(productGrids) {
  productGrids.forEach(initializeProductGrid);
  console.log('start');
}